import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  getPractitionerUsers,
  deleteUserAndProfile,
} from "../../features/auth/authSlice";
import { getPractitionerProfiles } from "../../features/practitionerProfiles/practitionerProfileSlice";
import { getAllEmailRecipients } from "../../features/emailCollection/emailCollectionSlice";
import { getUsers } from "../../features/user/userSlice";
import { useSelector, useDispatch } from "react-redux";
import { Link } from 'react-router-dom'
import {
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCardImage,
  MDBBtn,
  MDBRipple,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBRow,
  MDBCol,
} from "mdb-react-ui-kit";

export function Admin() {
  const { practitionerUsers, user } = useSelector((state) => state.auth);
  const { practitionerProfiles } = useSelector(
    (state) => state.practitionerProfiles
  );
  const { emailRecipients } = useSelector((state) => state.emailCollection);
  const { users } = useSelector((state) => state.user);
  console.log(users);
  //first modal
  const [basicModal, setBasicModal] = useState(false);
  //second modal
  const [twoBasicModal, setTwoBasicModal] = useState(false);
  const [threeBasicModal, setThreeBasicModal] = useState(false)

  const [fillActive, setFillActive] = useState("tab1");
  const [pendingVerification, setPendingVerification] = useState([]);
  const [alreadyVerified, setAlreadyVerified] = useState([]);
  const [choice, setChoice] = useState({});
  // const emailRecipients = useSelector((state) => state.emailCollection)
  const dispatch = useDispatch();

  // console.log(emailRecipients)

  useEffect(() => {
    dispatch(getPractitionerUsers());
    dispatch(getPractitionerProfiles());
    dispatch(getAllEmailRecipients());
    dispatch(getUsers());
  }, []);

  useEffect(() => {
    const verifiedUsers = practitionerUsers.filter(
      (item) => item.verified === true
    );
    setAlreadyVerified(verifiedUsers);

    const pendingUsers = practitionerUsers.filter(
      (item) => item.verified === false
    );
    setPendingVerification(pendingUsers);
  }, [practitionerUsers]);

  let string = "";
  const toggleShow = () => setBasicModal(!basicModal);
  const toggleShowTwo = () => setTwoBasicModal(!twoBasicModal);
  const toggleShowThree = () => setThreeBasicModal(!threeBasicModal)
  const handleFillClick = (value = string) => {
    if (value === fillActive) {
      return;
    }

    setFillActive(value);
  };

  const API_URL = "https://elana-api.herokuapp.com/api/practitionerUsers/";
  const verifyUser = async (verifiedData, userId) => {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    await axios
      .put(`${API_URL}admin/${userId}`, verifiedData, config)
      .then((res) => {
        if (res.data) {
          dispatch(getPractitionerUsers());
        }
      })
      .catch((err) => console.log(err));
  };
  console.log("Current Choice: ", choice);
  return (
    <div>
      <h1 className="fs-40-24 p-3 text-center">
        Current Admin: {user?.firstName} {user?.lastName}
      </h1>

      {/* CLICKABLE TABS */}
      <MDBTabs fill className="mb-3">
        <MDBTabsItem>
          <MDBTabsLink
            onClick={() => handleFillClick("tab1")}
            active={fillActive === "tab1"}
          >
            Pending
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink
            onClick={() => handleFillClick("tab2")}
            active={fillActive === "tab2"}
          >
            Verified
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink
            onClick={() => handleFillClick("tab3")}
            active={fillActive === "tab2"}
          >
            email
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink
            onClick={() => handleFillClick("tab4")}
            active={fillActive === "tab2"}
          >
            users
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>

      {/* MODAL VERIFY */}
      <MDBModal show={basicModal} setShow={setBasicModal} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                Are you sure you want to{" "}
                {choice.verified ? "unverify" : "verify"} this user?
              </MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={toggleShow}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <h2>
                {choice?.firstName} {choice?.lastName}
              </h2>
              <p>
                <strong>Practice Name:</strong> {choice?.practiceName}
              </p>
              <p>
                <strong>Practice Phone Number:</strong>{" "}
                {choice?.practicePhoneNumber}
              </p>
              <p>
                <strong>Email:</strong> {choice?.email}
              </p>
              <p>
                <strong>Address:</strong> {choice?.practiceAddress}
              </p>
              <p>
                <strong>Location:</strong> {choice?.location}
              </p>
              <p>
                <strong>Country:</strong> {choice?.country}
              </p>
            </MDBModalBody>

            <MDBModalFooter>
              
              <button
                className={
                  choice.verified ? "btn btn-warning" : "btn btn-success"
                }
                onClick={() => {
                  verifyUser({ verified: !choice.verified }, choice._id);
                  toggleShow();
                }}
              >
                {choice.verified ? "Unverify" : "Verify"}
              </button>
              <button className="btn btn-secondary" onClick={toggleShow}>
                Close
              </button>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      {/* MODAL DELETE */}
      <MDBModal show={twoBasicModal} setShow={setTwoBasicModal} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                Are you sure you want to delete this user?
              </MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={toggleShowTwo}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <h2>
                {choice?.firstName} {choice?.lastName}
              </h2>
              <p>
                <strong>Practice Name:</strong> {choice?.practiceName}
              </p>
              <p>
                <strong>Practice Phone Number:</strong>{" "}
                {choice?.practicePhoneNumber}
              </p>
              <p>
                <strong>Email:</strong> {choice?.email}
              </p>
              <p>
                <strong>Address:</strong> {choice?.practiceAddress}
              </p>
              <p>
                <strong>Location:</strong> {choice?.location}
              </p>
              <p>
                <strong>Country:</strong> {choice?.country}
              </p>
            </MDBModalBody>

            <MDBModalFooter>
            <button
                className="btn btn-danger"
                onClick={() => {
                  toggleShowTwo();
                  dispatch(deleteUserAndProfile(choice._id));
                }}
              >
                Delete User
              </button>
              <button className="btn btn-secondary" onClick={toggleShowTwo}>
                Close
              </button>
              
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      {/* MODAL EDIT */}
      <MDBModal show={threeBasicModal} setShow={setThreeBasicModal} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Are you sure you want to edit this user?</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleShowThree}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
            <h2>
                {choice?.firstName} {choice?.lastName}
              </h2>
              <p>
                <strong>Practice Name:</strong> {choice?.practiceName}
              </p>
              <p>
                <strong>Practice Phone Number:</strong>{" "}
                {choice?.practicePhoneNumber}
              </p>
              <p>
                <strong>Email:</strong> {choice?.email}
              </p>
              <p>
                <strong>Address:</strong> {choice?.practiceAddress}
              </p>
              <p>
                <strong>Location:</strong> {choice?.location}
              </p>
              <p>
                <strong>Country:</strong> {choice?.country}
              </p>
            </MDBModalBody>

            <MDBModalFooter>
                <Link to={`/admin/edit/${choice._id}`}>
              <MDBBtn>
                  Edit
                </MDBBtn>
                </Link>
              <MDBBtn color='secondary' onClick={toggleShowThree}>
                Close
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      {/* TAB PAGES */}
      <MDBTabsContent>
        {/* TAB 1 */}
        <MDBTabsPane show={fillActive === "tab1"}>
          {pendingVerification.length === 0 && (
            <h2 className="text-center p-5">
              No practitioners pending verification...
            </h2>
          )}
          <MDBRow className="">
            {pendingVerification.map((item, index) => {
              if (item.verified === false) {
                const profile = practitionerProfiles.find((data) => {
                  if (data._id === item.profile) {
                    return data;
                  }
                });
                return (
                  <MDBCol size="12" lg="3" md="4" sm="6" xs="12" key={index}>
                    <MDBCard className="m-4">
                      <MDBCardImage
                        src={
                          profile?.image
                            ? profile?.image
                            : "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn1.iconfinder.com%2Fdata%2Ficons%2Fui-colored-1%2F100%2FUI__26-512.png&f=1&nofb=1"
                        }
                        className="imageAdmin"
                        alt="profile"
                      />
                      <MDBCardBody>
                        <MDBCardTitle>
                          <h2 className="text-center">
                            {item?.firstName} {item.lastName}
                          </h2>
                        </MDBCardTitle>
                        <MDBCardText>
                          <p>
                            <strong>Practice Name:</strong> {item?.practiceName}
                          </p>
                          <p>
                            <strong>Practice Phone Number:</strong>{" "}
                            {item?.practicePhoneNumber}
                          </p>
                          <p>
                            <strong>Email:</strong> {item?.email}
                          </p>
                          <p>
                            <strong>Address:</strong> {item?.practiceAddress}
                          </p>
                          <p>
                            <strong>Location:</strong> {item?.location}
                          </p>
                          <p>
                            <strong>Country:</strong> {item?.country}
                          </p>
                        </MDBCardText>
                        <div className="d-flex justify-content-evenly">
                          <button
                            className="btn btn-success px-5 py-2"
                            onClick={() => {
                              toggleShow();
                              setChoice(item);
                            }}
                          >
                            Verify
                          </button>
                          <button
                          className="btn btn-info px-5 py-2"
                          onClick={() => {
                            toggleShowThree()
                            setChoice(item)
                          }}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => {
                              toggleShowTwo();
                              setChoice(item);
                            }}
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </MDBCardBody>
                    </MDBCard>
                  </MDBCol>
                );
              }
            })}
          </MDBRow>
        </MDBTabsPane>

        {/* TAB 2 */}
        <MDBTabsPane show={fillActive === "tab2"}>
          <MDBRow className="mb-5">
            {alreadyVerified.map((item, index) => {
              if (item.verified === true) {
                const profile = practitionerProfiles.find((data) => {
                  if (data._id == item.profile) {
                    return data;
                  }
                });
                return (
                  <MDBCol size="12" lg="3" md="4" sm="6" xs="12" key={index}>
                    <MDBCard className="m-4">
                      <MDBCardImage
                        src={
                          profile?.image
                            ? profile?.image
                            : "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn1.iconfinder.com%2Fdata%2Ficons%2Fui-colored-1%2F100%2FUI__26-512.png&f=1&nofb=1"
                        }
                        className="imageAdmin"
                        alt="profile"
                      />
                      <MDBCardBody>
                        <MDBCardTitle>
                          <h2 className="text-center">
                            {item.firstName} {item.lastName}
                          </h2>
                        </MDBCardTitle>
                        <MDBCardText>
                          <p>
                            <strong>Practice Name:</strong> {item.practiceName}
                          </p>
                          <p>
                            <strong>Practice Phone Number:</strong>{" "}
                            {item.practicePhoneNumber}
                          </p>
                          <p>
                            <strong>Email:</strong> {item.email}
                          </p>
                          <p>
                            <strong>Address:</strong> {item.practiceAddress}
                          </p>
                          <p>
                            <strong>Location:</strong> {item.location}
                          </p>
                          <p>
                            <strong>Country:</strong> {item.country}
                          </p>
                        </MDBCardText>
                        <div className="d-flex justify-content-between">
                          <button
                            className="btn btn-warning px-5 py-2"
                            onClick={() => {
                              toggleShow();
                              setChoice(item);
                              // setChoice({name: `${item.firstName} ${item.lastName}`, id: item._id, verified: !item.verified})
                            }}
                          >
                            Unverify
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => {
                              toggleShowTwo();
                              setChoice(item);
                            }}
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </MDBCardBody>
                    </MDBCard>
                  </MDBCol>
                );
              }
            })}
          </MDBRow>
        </MDBTabsPane>

        <MDBTabsPane show={fillActive === "tab3"}>
          {emailRecipients.map((item) => {
            return (
              <div>
                <h2>newsletter</h2>
                <h1>{item.email}</h1>
              </div>
            );
          })}
        </MDBTabsPane>

        <MDBTabsPane show={fillActive === "tab4"}>
        <h2>users</h2>
          {users.map((item) => {
            return (
              <div className="d-flex">
                <div className="card-user mt-3">
                <h1>First Name: <span>{item.firstName}</span></h1>
                <h1>Last Name: <span>{item.lastName}</span></h1>
                <h1>Email: <span>{item.email}</span></h1>
                </div>
              
              </div>
            );
          })}
        </MDBTabsPane>
      </MDBTabsContent>
    </div>
  );
}
